import { createConfigSelector, getActiveLocaleSelector, getEnvironmentSelector } from '@americanexpress/travel-selectors';
import { RootStateOrAny } from 'react-redux';
import { createSelector } from 'reselect';
import { E3 } from '../constants/commonConstants';

export const getMembershipDomainApiUrl = createConfigSelector('tlsMembershipDomain');

export const getOneCmsBaseURLSelector: (state: RootStateOrAny) => string = createConfigSelector('oneCMSInternetSSRBaseUrl');

export const getPersonaApiUrl = createConfigSelector('personaApiUser');

export const getNavigationOneCmsUrlSelector = createSelector(
  getOneCmsBaseURLSelector,
  getActiveLocaleSelector,
  getEnvironmentSelector,
  (oneCmsDomain, locale, env) => (env === E3
    ? `${oneCmsDomain}/Internet/travel/travel-header/${locale.toLowerCase()}/navigation-links.json`
    : `${oneCmsDomain}/Internet/travel/travel-header/${locale.toLowerCase()}/navigation-links-qa.json`)
);
